import React from 'react';
import { Link } from 'react-router-dom';
import Copyright from './Copyright';

const FooterOne = () => {
    return(
        <>
        {/*Main Footer*/}
        <footer className="footer">
            <div className="default-container">
            {/*Widgets Section*/}
            <div className="widgets-section">
                <div className="row clearfix">
                {/*Column*/}
                <div className="big-column col-lg-12">
                    <div className="row clearfix">
                    {/*Footer Column*/}
                    <div className="footer-col col-lg-3">
                        <div className="footer-widget logo-widget">
                        <div className="logo">
                            <Link to="/"><img src="images/logo.png" alt="" /></Link>
                        </div>
                        <div className="text">621 Columbia Rd #38, Magnolia, AR, 71753</div>
                        <ul className="list-style-one">
                            <li><span>Phone:</span> <a href="tel:+1234567890">+123 456 7890</a></li>
                            <li><span>Email:</span> <a href="mailto:support@example.com">support@example.com</a></li>
                            <li><span>Working Hours:</span> Mon - Fri: 9.00am - 5.00pm</li>
                        </ul>
                        <ul className="social-icon">
                            <li><Link to="#"><i className="fa fa-facebook" /></Link></li>
                            <li><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                            <li><Link to="#"><i className="fa fa-vimeo" /></Link></li>
                            <li><Link to="#"><i className="fa fa-pinterest" /></Link></li>
                            <li><Link to="#"><i className="fa fa-instagram" /></Link></li>
                        </ul>
                        </div>
                    </div>
                    <div className="footer-col col-lg-3">
                        <div className="footer-widget posts-widget">
                        <h2>Recent Posts</h2>
                        <article className="post">
                            <div className="text"><Link to="/blog-single">Isolate &amp; Reframe Your Beliefs</Link></div>
                            <ul className="post-date">
                            <li><i className="fa fa-user" /> By Admin</li>
                            <li>MAY 25 2022</li>
                            </ul>
                        </article>
                        <article className="post">
                            <div className="text"><Link to="/blog-single">Take Action For Your Business</Link></div>
                            <ul className="post-date">
                            <li><i className="fa fa-user" /> By Admin</li>
                            <li>MAY 25 2022</li>
                            </ul>
                        </article>
                        <article className="post">
                            <div className="text"><Link to="/blog-single">Improve Your Business Ideas</Link></div>
                            <ul className="post-date">
                            <li><i className="fa fa-user" /> By Admin</li>
                            <li>MAY 25 2022</li>
                            </ul>
                        </article>
                        </div>
                    </div>
                    <div className="footer-col col-lg-3">
                        <div className="footer-widget links-widget">
                        <h2>Quick Links</h2>
                        <ul className="footer-link">
                            <li><Link to="#">About Us</Link></li>
                            <li><Link to="#">Our Services</Link></li>
                            <li><Link to="#">Testimonials</Link></li>
                            <li><Link to="#">Latest News</Link></li>
                            <li><Link to="#">Privacy Policy</Link></li>
                        </ul>
                        </div>
                    </div>
                    <div className="footer-col col-lg-3">
                        <div className="footer-widget newsletter-widget">
                        <h2>Our Newsletter</h2>
                        <div className="text">Get in your inbox the latest News and Offers from ploting</div>
                        <div className="newsletter-form">
                            <form method="post" action="#">
                            <div className="form-group">
                                <input type="email" name="email" placeholder="Email address" required />
                            </div>
                            <div className="form-group">
                                <button type="submit" className="ploting-btn btn-style-one">Subscribe</button>
                            </div>
                            </form>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
            <Copyright />
        </footer>
        {/*End Main Footer*/}
        </>
    )
}

export default FooterOne;